import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../../../../../shared/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: false,
})
export class LoginComponent implements OnInit {

  form: FormGroup;

  erroLogin = false;
  loading = false;
  mensagemSessao: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      login: ['', Validators.required],
      senha: ['', Validators.required],
    });

    const state = this.router.getCurrentNavigation()?.extras.state ?? window.history.state;
    this.mensagemSessao = (state as { mensagem?: string })?.mensagem ?? null;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.erroLogin = false;

    const { login, senha } = this.form.value;

    this.authService.login(login!, senha!).subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: () => {
        this.erroLogin = true;
        this.loading = false;
        this.mensagemSessao = '';
      },
    });
  }

  isInvalid(campo: string): boolean {
    const control = this.form.get(campo);
    return !!control && control.invalid && control.touched;
  }
}
